/* eslint-disable eqeqeq */
import React, { FC } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { withProcedureWraper } from "../../../..";
import { Routes } from "../../../../../../AppRoutes";
import { Box } from "../../../../../../components/box";
import { Icon } from "../../../../../../components/icon";
import { CreateForm } from "./create-form";
import { EditForm } from "./edit-form";

export const CreateCourseStaff: FC = withProcedureWraper(() => {
  const { id } = useRouteMatch().params as any;
  const history = useHistory();

  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div
              className="btnBack"
              onClick={() => history.push(Routes.courseStaffPage.path)}
            >
              <Icon.ArrowLeft />
            </div>
            {id != 0
              ? "CHỈNH SỬA PHIẾU THAY ĐỔI/ BỔ SUNG NHÂN SỰ KHÓA HỌC"
              : "TẠO PHIẾU THAY ĐỔI/ BỔ SUNG NHÂN SỰ KHÓA HỌC"}
          </div>
        </div>
        <Box title="Nội dung đề nghị">
          {id == 0 && <CreateForm />}
          {id != 0 && <EditForm />}
        </Box>
      </div>
    </div>
  );
});
